import { render, staticRenderFns } from "./PackageIframe.vue?vue&type=template&id=e1d3f676&scoped=true"
import script from "./PackageIframe.vue?vue&type=script&lang=js"
export * from "./PackageIframe.vue?vue&type=script&lang=js"
import style0 from "./PackageIframe.vue?vue&type=style&index=0&id=e1d3f676&prod&lang=scss"
import style1 from "./PackageIframe.vue?vue&type=style&index=1&id=e1d3f676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d3f676",
  null
  
)

export default component.exports